import moment from "moment";
class activities {
  constructor(
    movimId,
    realizadoPor,
    tipoProceso,
    proceso,
    paso,
    enLaFecha,
    estado,
    empleado,
    concepto,
    conceptoId,
    licTot,
    csCosto,
    csCostoId,
    desde,
    hasta,
    horario,
    secuencia,
    diaIni,
    fechaLiq,
    sCantLiq,
    sCantAut,
    sCantNoAut,
    fichada,
    delega,
    delegado,
    cantLiq,
    cantAut,
    cantNoAut
  ) {
    function hours(param) {
      let horas = Math.floor(param / 60);
      let min = Math.floor(horas * 60);
      min = param - min;
      if (horas < 10) {
        horas = "0" + horas;
      }
      min = min < 10 ? "0" + min : min;
      return horas + ":" + min;
    }
    function change(param) {
      switch (param) {
        case "LICE":
          return "Pedido de licencia";
        case "CHOR":
          return "Cambio de horario";
        case "DELE":
          return "Delegación de mando";
        case "LICF":
          return "Fichada en licencia";
        case "HSEX":
          return "Autorizacíon de extras";

        default:
          break;
      }
    }
    function formattedDateTime(desde, hasta) {
      const formatDateTime = (date) => {
        return moment(date).utc().format("DD-MM-YYYY HH:mm");
      };
    
      const formatDateOnly = (date) => {
          return moment(date).utc().format("DD-MM-YYYY");
      };
    
      
      const isMidnightRange = desde && hasta && desde.includes("T00:00:00.000Z") && hasta.includes("T00:00:00.000Z");
    
    
      const formattedDesde = desde ? (isMidnightRange ? formatDateOnly(desde) : formatDateTime(desde)) : "";
      const formattedHasta = hasta ? (isMidnightRange ? formatDateOnly(hasta) : formatDateTime(hasta)) : "";
    
      return { desde: formattedDesde, hasta: formattedHasta };
        
    }
  

    this.movimId = movimId;
    this.delegadoPor = realizadoPor;
    this.proceso = proceso;
    this.tipoProceso = change(tipoProceso);
    this.paso = paso;
    this.realizadoPor =  realizadoPor;
    this.enLaFecha = enLaFecha ? moment(enLaFecha).utc().format("DD-MM-YYYY") : "";
    this.estado = estado;
    this.empleado = empleado;
    this.concepto = concepto;
    this.conceptoId = conceptoId;
    this.licTot = licTot;
    this.csCosto = csCosto;
    this.csCostoId =  csCostoId
    this.desde = formattedDateTime(desde, hasta).desde;
    this.hasta = formattedDateTime(desde,hasta).hasta;
    this.horario = horario;
    this.secuencia = secuencia;
    this.diaInicio = diaIni ? moment(diaIni).utc().format("DD-MM-YYYY"): "";
    this.fechaLiq = fechaLiq ? moment(fechaLiq).utc().format("DD-MM-YYYY"): "";
    this.sCantLiq = sCantLiq;
    this.sCantAut = sCantAut;
    this.sCantNoAut = sCantNoAut;
    this.fichada = fichada;
    this.delega= delega;
    this.delegado = delegado;
    this.cantLiq = hours(cantLiq);
    this.cantAut = hours(cantAut);
    this.cantNoAut = hours(cantNoAut);
  }
  static fromJson({
      movimId,
      realizadoPor,
      tipoProceso,
      proceso,
      paso,
      enLaFecha,
      estado,
      empleado,
      concepto,
      conceptoId,
      licTot,
      csCosto,
      csCostoId,
      desde,
      hasta,
      horario,
      secuencia,
      diaIni,
      fechaLiq,
      sCantLiq,
      sCantAut,
      sCantNoAut,
      fichada,
      delega,
      delegado,
      cantLiq,
      cantAut,
      cantNoAut
  }) {
    return new activities(
      movimId,
      realizadoPor,
      tipoProceso,
      proceso,
      paso,
      enLaFecha,
      estado,
      empleado,
      concepto,
      conceptoId,
      licTot,
      csCosto,
      csCostoId,
      desde,
      hasta,
      horario,
      secuencia,
      diaIni,
      fechaLiq,
      sCantLiq,
      sCantAut,
      sCantNoAut,
      fichada,
      delega,
      delegado,
      cantLiq,
      cantAut,
      cantNoAut
    );
  }
}

export default activities;
